import { FC } from 'react'
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom'
import { RowActions, useToast } from '../../../../../../components'
import {
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteEspecialidadeVinculo } from '../../core/_requests'
import { FormularioEmpresaList } from '../../core/_models'

type Props = {
  vinculo: FormularioEmpresaList
}

export const EspecialidadeVinculosActionsCell: FC<Props> = ({ vinculo }) => {
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { id } = useParams()
  const formId = Number(id)

  const nome = [vinculo.especialidade?.nome, vinculo.unidade?.nome ?? vinculo.empresa?.nomeFantasia]
    .filter(Boolean)
    .join(' · ')

  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir vínculo?',
      text: `O formulário deixa de ser usado em ${nome || 'este vínculo'}.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteEspecialidadeVinculo(
        formId,
        vinculo.especialidade?.id,
        vinculo.empresa?.id,
        vinculo.unidade?.id
      )
      Swal.close()
      showToast({ variant: 'success', title: 'Vínculo excluído.' })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={`vínculo ${nome}`}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
